/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import "jspdf-autotable";
import TableHeader from "../../Common/TableHeader";
import ajaxStudent from "../../../util/remote/ajaxStudent";
import Loader from "../../Common/Loader";
import Pagination from "../../Common/Pagination";
import useStateCallback from "../../../util/customHooks/useStateCallback";
import ActivationsFilterForm from "../../Common/Statistics/ActivationsFilterForm";

function ActivationsList() {
  const [query, setQuery] = useState("");
  const [school, setSchool] = useState("");
  const [startDate, setStartDate] = useState("");

  const [endDate, setEndDate] = useState("");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const [meta, setMeta] = useState([]);
  const [accountActivations, setAccountActivations] = useState([]);
  const [modal, setModal] = useStateCallback(false);

  useEffect(() => {
      if (query || school || startDate || endDate) {
          searchAccountActivations();
      } else {
          getAccountActivations(page);
      }
  }, [page]);
  
  const getAccountActivations = async (currentPage) => {
      setLoading(true);
      const server_response = await ajaxStudent.listAllActivations(currentPage);
      setLoading(false);
      if (server_response.status === "OK") {
        setMeta(server_response.details.meta.totalPages);
        setAccountActivations(server_response.details.data || []);
      } else {
        setAccountActivations([]);
      }
  };

  const searchAccountActivations = async (e) => {
      if (e) {
        e.preventDefault();
      }
      setLoading2(true);
      const server_response = await ajaxStudent.searchAllActivations(page,school,query,startDate,endDate);
      setLoading2(false);
      if (server_response.status === "OK") {
        setMeta(server_response.details.meta.totalPages);
        setAccountActivations(server_response.details.data || []);
      } else {
        setAccountActivations([]);
      } 
  };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };

  const handleFilter = () => {
    setModal(false, () => setModal(<ActivationsFilterForm g={setAccountActivations} h={setMeta} page={page} isOpen={true}/>));
  };

  const setActivations = (e) => {
    e.preventDefault();
    setQuery("");
    setSchool("");
    setStartDate("");
    setEndDate("");
    setPage(1);
    getAccountActivations(1);
    
  };


  return (
    <div className="col-lg-12 col-md-12 mt-3">
      {modal}
              <div className="card height-auto">
                <div className="card-body">
                <div class="heading-layout1 mg-b-5">
        <TableHeader
          title = "Account Activations List"
          subtitle="List of all the account activations sorted by the most recent"    
        />
        <div class="dropdown">
          <Link class="dropdown-toggle" role="button" data-toggle="dropdown" aria-expanded="false">...</Link>
          <div class="dropdown-menu dropdown-menu-right">
            <Link class="dropdown-item" onClick={setActivations}> <i class="fas fa-redo-alt text-orange-peel"></i>Refresh</Link>
            <Link class="dropdown-item" onClick={handleFilter}> <i class="fas fa-filter"></i>Filter</Link>

          </div>
        </div>
      </div>

      <div className="border-top mt-3"></div>
      <div className="table-responsive">
      {loading || loading2 ? (
        <Loader />
                      ) : (
        <table className="table display data-table text-nowrap">
            <thead>
                <tr>
                <th scope="col">Activation Date</th>
                <th scope="col">Student Name</th>
                <th scope="col"> School</th>
                <th scope="col"> Activated By</th>

                </tr>
            </thead>
            <tbody>
                {accountActivations.length > 0 ? (
                    accountActivations.map((item, index) => (
                    <tr key={index}>
                        

                        <td>
                        {item.created_at?.short_date}
                        <br />
                      <small>
                      {item.created_at?.time}
                      </small>
                        </td>
                        
                        <td>
                            {item.last_name} {item.first_name}
                            <br />
                            <small>{item.username}</small>
                        </td>
                        <td>{item.school_name}</td>
                        <td>{item.activated_by? item.activated_by.full_name :"N/A"}
                        <br />
                        <small>{item.activated_by? item.activated_by.role_name:""}</small>
                        </td>
                    </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="3" style={{ textAlign: "center" }}>
                            No account activations yet.
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
      )}
        
      </div>
      <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
                </div>
              </div>
          </div>
  );
}

export default ActivationsList;
